module.exports = __webpack_public_path__ + "static/media/inetcpl_1310.43fe3f4d.ico";